export const HomepageProjectDescriptionOne = () => {
  return (
    <div className="project-description-container">
      <h2>Text Q&amp;A</h2>
      <p>
        An interactive, real-time question-and-answer app purposed to enhance
        experience of both host and guest.
      </p>
    </div>
  );
};
